import axios, { RawAxiosRequestHeaders } from 'axios'

interface Read {
  url: string
  params?: Object
  headers?: RawAxiosRequestHeaders
}

interface Write {
  url: string
  params?: Object
  body?: Object
  headers?: RawAxiosRequestHeaders
}

/**
 * Custom fetch helper overriding HTTP GET method
 * @param {Object} data - Fetcher data object
 * @param {string} data.url - URL of the server that will be used for the request
 * @param {Object} data.params - URL prameters that will be sent with the request
 */
const fetcher = ({ url, params, headers }: Read) =>
  axios
    .get(url, {
      params,
      headers
    })
    .then((res) => res.data)

/**
 * Custom create helper overriding HTTP POST method
 * @param {Object} data - Creator data object
 * @param {string} data.url - URL of the server that will be used for the request
 * @param {Object} data.params - URL prameters that will be sent with the request
 * @param {Object} data.body - Body that will be sent with the request
 */
const creator = ({ url, params, body, headers }: Write) =>
  axios
    .post(url, body, {
      params,
      headers
    })
    .then((res) => res.data)

/**
 * Custom create helper overriding HTTP Patch method
 * @param {Object} data - Patcher data object
 * @param {string} data.url - URL of the server that will be used for the request
 * @param {Object} data.params - URL prameters that will be sent with the request
 * @param {Object} data.body - Body that will be sent with the request
 */
const patcher = ({ url, params, body, headers }: Write) =>
  axios
    .put(url, body, {
      params,
      headers
    })
    .then((res) => res.data)

/**
 * Custom remover helper overriding HTTP Delete method
 * @param {Object} data - Remove data object
 * @param {string} data.url - URL of the server that will be used for the request
 * @param {Object} data.body - Body that will be sent with the request
 */
const remover = ({ url, body }: Write) =>
  axios.delete(url, body).then((res) => res.data)

export { fetcher, creator, patcher, remover }
